<template>
  <div class="Feedback" ref="feedbackContainer">
    <div :class="['positive', { active: isPositiveFeedback } ]">
      <span :style="{ backgroundImage: 'url(' + require('@/assets/images/' + locale.LOCALE + '/feedback_great.png') + ')' }" ref="spanPositive">
          {{ locale.GREAT }}
      </span>
    </div>
    <div :class="['negative', { active: !isPositiveFeedback } ]">
      <span :style="{ backgroundImage: 'url(' + require('@/assets/images/' + locale.LOCALE + '/feedback_try_again.png') + ')' }" ref="spanNegative">
          {{ locale.TRY_AGAIN }}
      </span>
    </div>
  </div>
</template>

<script>

import { tryAgainAudio, greatAudio } from '@/audio'

import { TweenLite, Power0 } from 'gsap'

export default {
  name: 'Feedback',
  props: {
    feedbackType: Number,
    onAnimationComplete: Function
  },
  data() {
    return {

    }
  },
  computed: {
    isPositiveFeedback() { return this.feedbackType > 0 },
    locale() { return this.$store.state.lang },
  },
  methods: {
      playAnimation() {

          const { feedbackContainer, spanPositive, spanNegative } = this.$refs

          const onStart = () => {
            ( this.isPositiveFeedback ) ? greatAudio.play() : tryAgainAudio.play()
          }

          const onComplete = () => {
            TweenLite.to( feedbackContainer, 0.1, {
              autoAlpha: 0,
              onComplete: () => {
                  this.onAnimationComplete
              }
            } )
          }

          TweenLite.set( feedbackContainer, { autoAlpha: 0 } )

          TweenLite.fromTo([spanPositive, spanNegative], 0.2, { y:'50%' }, { y:'-50%' } )

          TweenLite.to( feedbackContainer, 0.2, {
              autoAlpha: 1,
              onComplete,
              onStart
          } )
      }
  },
  mounted() {
      const { feedbackContainer, spanPositive, spanNegative } = this.$refs

      TweenLite.to( feedbackContainer, 0, { autoAlpha: 0 } )
      TweenLite.to( spanPositive, 0, { y: '50%' } )
      TweenLite.to( spanNegative, 0, { y: '50%' } )
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .Feedback {

    width: 100%;
    height: 100%;

    min-height: $page-min-height;

    position: absolute;
    top: 0;
    left: 0;

    opacity: 0.5;

    @include breakpoint( mobile-all ) {

      min-height: 100%;
    }

    @include brightnessContrastFilter();

    .positive,
    .negative {
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      display: none;

      &.active {

        display: block;

      }
    }

    .positive {
      background-image: url('~@/assets/images/feedback_positive_gradient.png')
    }

    .negative {
      background-image: url('~@/assets/images/feedback_negative_gradient.png')
    }

    // @keyframes show-message {
    //   0% { transform: translateY(50%) }
    //   100% { transform: translateY(-50%) }
    // }

    span {
      position: absolute;
      left: 0;
      bottom: rem( 140 );
      display: block;
      width: 100%;
      height: 5%;

      transform: translateY(50%);
      // animation: show-message 0.4s ease-out 0s 1 forwards;

      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto 100%;

      font-size: 0;

      @include breakpoint( mobile-all ) {

        bottom: rem( 160 );

      }

      @include breakpoint-width( 375px, 667px ) {

        bottom: rem( 120 );

      }
    }

  }

</style>
